export default "__VITE_ASSET__D1p$6kGT__"